import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { LookupGridComponent } from '@farris/ui-lookup';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[lookupGridRef]'
})
export class LookupGridComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: LookupGridComponent, public elementRef: ElementRef, public frameContext: FrameContext) {
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }

}